module.exports = __webpack_public_path__ + "static/media/fr_podcast_player_pause_icon.9df83335.svg";